import http from "./http-service"

export default class CustomerService {

  static isDefaultCustomer = (customer) => {
    return (customer && customer.code === "000000" && customer.unit === "00")
  }

  static getByCode(code, unit) {
    return http.get(`customers/${code}/${unit}`)
  }

  static getByCnpj(cnpj) {
    return http.get(`customers/${cnpj}`)
  }

  static getOpenReceivables(code, unit) {
    return http.get(`open-receivables/${code}/${unit}`).then((response) => response.receivables)
  }

  static getCities(state) {
    return http.get(`cities/${state}`).then((response) => response.cities)
  }

  static getSegments() {
    return http.get("segments").then((response) => response.segments)
  }

  static create(customer) {
    return http.post("customers", customer)
  }

  static search(data) {
    return http.post("customers/search", data).then((response) => response.customers)
  }

  static customerAddress(customer) {

    if (!customer)
      return ""

    let address = customer.address ? customer.address.trim() : ""

    if (customer.city) {
      if (address)
        address += " - "
      address +=  customer.city.trim()
    }          

    if (customer.state) {
      if (address)
        address += " / "
      address += customer.state  
    }  

    return address
  }

  static billingAddress(customer) {

    if (!customer)
      return ""

    let address = customer.billAddress ? customer.billAddress.trim() : ""

    if (customer.billCity) {
      if (address)
        address += " - "
      address +=  customer.billCity.trim()
    }          

    if (customer.billState) {
      if (address)
        address += " / "
      address += customer.billState  
    }  

    return address
  }
}